import { render, staticRenderFns } from "./ApexGeneric.vue?vue&type=template&id=fa68ef20"
import script from "./ApexGeneric.vue?vue&type=script&lang=js"
export * from "./ApexGeneric.vue?vue&type=script&lang=js"
import style0 from "./ApexGeneric.vue?vue&type=style&index=0&id=fa68ef20&prod&lang=css"


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports